import { gql } from '@apollo/client';

const UPDATE_UPCOMING_ACADEMIC_SESSION_SETTING = gql`
  mutation updateUpcomingAcademicSessionSetting($organizationId: Int!, $value: JSON!) {
    saveOrganizationSetting(
      where: { appId: null, organizationId: $organizationId, setting: "upcomingAcademicSession" }
      value: $value
    ) {
      id
      organizationId
      setting
      value
    }
  }
`;

export default UPDATE_UPCOMING_ACADEMIC_SESSION_SETTING;
